<div class="comp-header">
  <h1 class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">Opret serviceaftale</h1>
  <div class="comp-header__close">
    <span (click)="onCloseClick()"><mat-icon class="icon-close" svgIcon="remove"></mat-icon></span>
  </div>
</div>
<div class="service service--create padding--bottom-xl">
  <mat-vertical-stepper #stepper [linear]="true">
    <mat-step
      [completed]="
        kunde &&
        !kunde?.areaBlacklist?.isPostalCodeBlacklisted == true &&
        !kunde?.areaBlacklist?.isLocationBlacklisted == true &&
        !kunde?.areaBlacklist?.isPostalAndLocationBlacklisted == true
      "
      #kundeStep
      >
      <ng-template matStepLabel>
        <div>Kundeinformation</div>
        @if (stepper.selectedIndex > 0) {
          <div class="summary">
            <span>{{ kunde?.anlaegsadresse?.name }}</span>
            @if (kunde?.anlaegsadresse?.adressLine) {
              <span class="separator">⋅</span>
            }
            <span>{{ kunde?.anlaegsadresse?.adressLine }}</span>
            @if (kunde?.anlaegsadresse?.email) {
              <span class="separator">⋅</span>
            }
            <span>{{ kunde?.anlaegsadresse?.email }}</span>
            @if (kunde?.anlaegsadresse?.phone) {
              <span class="separator">⋅</span>
            }
            <span>{{ $safeNavigationMigration(kunde?.anlaegsadresse?.phone) | dkPhoneNumber }}</span>
          </div>
        }
      </ng-template>
      <app-kunde-form
        [form]="kundeForm"
        [serviceaftale]="serviceaftale"
        [kunde]="kunde"
        (reload)="reloadKundeinformation()"
      ></app-kunde-form>
      @if (
        kunde?.areaBlacklist?.isPostalCodeBlacklisted == true ||
        kunde?.areaBlacklist?.isLocationBlacklisted == true ||
        kunde?.areaBlacklist?.isPostalAndLocationBlacklisted == true
        ) {
        <span
          class="red icon-with-text"
          >
          <mat-icon svgIcon="alert-solid" class="mat-icon--red icon-48"></mat-icon>
          OK kan ikke tilbyde service i dette område: {{ kunde?.areaBlacklist?.matchedBlacklistWord }}
        </span>
      }
      @if (kreditvurdering?.kreditvaerdig == kreditvurderingEnum.No) {
        <div>
          <span class="red icon-with-text">
            <mat-icon svgIcon="alert-solid" class="mat-icon--red icon-48"></mat-icon>
            <p>Kunden er ikke kreditværdig!</p>
          </span>
          <p>{{ kreditvurdering.aarsagTekst }}</p>
        </div>
      }
      @if (kreditvurdering?.kreditvaerdig == kreditvurderingEnum.Maybe) {
        <div>
          <span class="orange icon-with-text">
            <mat-icon svgIcon="alert-solid" class="mat-icon--red icon-48"></mat-icon>
            <p>Kunden er muligvis ikke kreditværdig!</p>
          </span>
          <p>{{ kreditvurdering.aarsagTekst }}</p>
        </div>
      }
      <div class="form-btns">
        <button mat-raised-button (click)="reset()" [disabled]="!kunde">Nulstil</button>
        <button
          mat-raised-button
          matStepperNext
          color="primary"
          [disabled]="
            !kunde ||
            kunde?.areaBlacklist?.isPostalCodeBlacklisted == true ||
            kunde?.areaBlacklist?.isLocationBlacklisted == true ||
            kunde?.areaBlacklist?.isPostalAndLocationBlacklisted == true
          "
          >
          Videre
        </button>
      </div>
    </mat-step>
    <mat-step [stepControl]="produktForm" #produktStep>
      <ng-template matStepLabel>
        <div>Produkter & Anlæg</div>
        @if (stepper.selectedIndex > 1) {
          <div class="summary">
            <span>{{ produkt?.text }}</span>
            @if (selectedFabrikat) {
              <span class="separator">⋅ {{ selectedFabrikat.name }}</span>
            }
            @if (selectedModel) {
              <span class="separator">⋅ {{ selectedModel.name }}</span>
            }
            @if (produktInformation?.alternativModel) {
              <span class="separator">⋅ {{ produktInformation?.alternativModel }}</span>
            }
            @if (produktInformation?.effekt.minEffekt || produktInformation?.effekt.maxEffekt) {
              <span class="separator">⋅</span>
            }
            @if (
              !produktInformation?.effekt.minEffekt ||
              (produktInformation?.effekt.minEffekt && produktInformation?.effekt.minEffekt == produktInformation?.effekt.maxEffekt)
              ) {
              <span
                >
                {{ produktInformation?.effekt.maxEffekt }} KW
              </span>
            }
            @if (produktInformation?.effekt.minEffekt && produktInformation?.effekt.minEffekt != produktInformation?.effekt.maxEffekt) {
              <span
                >
                {{ produktInformation?.effekt.minEffekt }}-{{ produktInformation?.effekt.maxEffekt }} KW
              </span>
            }
          </div>
        }
      </ng-template>
      <app-produkt-form
        [form]="produktForm"
        [fabrikater]="fabrikater"
        [modeller]="modeller"
        [products]="products"
        [kunde]="kunde"
        (productChange)="onProductChange($event)"
      ></app-produkt-form>
      <div class="form-btns">
        <button mat-raised-button matStepperPrevious>Tilbage</button>
        <button mat-raised-button matStepperNext color="primary" [disabled]="!produktForm.valid">Videre</button>
      </div>
    </mat-step>
    <mat-step [stepControl]="abonnementForm">
      <ng-template matStepLabel>
        <div>Abonnement</div>
        @if (stepper.selectedIndex > 2) {
          <div class="summary">
            <span>{{ subscription?.description }}</span>
            @if (abonnementInformation?.nextCheckupDate) {
              <span class="separator">⋅</span>
              <span>Eftersyn: {{ $safeNavigationMigration(abonnementInformation?.nextCheckupDate) | date : 'dd.MM.yyyy' }}</span>
            }
            @if (abonnementInformation?.opkraevningDate) {
              <span class="separator">⋅</span>
              <span>Opkrævning: {{ $safeNavigationMigration(abonnementInformation?.opkraevningDate) | date : 'dd.MM.yyyy' }}</span>
            }
          </div>
        }
      </ng-template>
      <app-abonnement-form
        [form]="abonnementForm"
        [tags]="tags"
        [subscribtions]="subscribtions"
        (abonnementChange)="onAbonnementChange($event)"
        [partners]="partners"
        [henvisere]="henvisere"
        [produktId]="$safeNavigationMigration(produkt?.id)"
        [isanlaegNewlyInstalled]="isanlaegNewlyInstalled"
        (selectedPartner)="onSelectedPartnerChange($event)"
        (startdateChanged)="onStartdateChange($event)"
      ></app-abonnement-form>
      <div class="form-btns">
        <button mat-raised-button matStepperPrevious>Tilbage</button>
        <button mat-raised-button matStepperNext color="primary" [disabled]="!abonnementForm.valid">Videre</button>
      </div>
    </mat-step>
    @if (!subscription.isTilkaldsabonnement) {
      <mat-step [stepControl]="tilvalgForm">
        <ng-template matStepLabel>
          <div>Tilvalg</div>
          @if (stepper.selectedIndex > 3) {
            <div class="summary">
              @if (tilvalgInformation?.fastPrisEnabled) {
                <div>
                  <span>Fast pris: {{ tilvalgInformation.fastPris | dkCurrency }}</span>
                  @if (tilvalgInformation.fixedPriceStartDate) {
                    <span class="separator">⋅</span>
                    <span>Start dato: {{ tilvalgInformation.fixedPriceStartDate | date : 'dd.MM.yyyy' }}</span>
                  }
                  @if (tilvalgInformation.fixedPriceEndDate) {
                    <span class="separator">⋅</span>
                    <span>Udløbs dato: {{ tilvalgInformation.fixedPriceEndDate | date : 'dd.MM.yyyy' }}</span>
                  }
                </div>
              }
              @if (tilvalgInformation?.rabatEnabled) {
                <div>
                  @if (tilvalgInformation.rabatKontant) {
                    <span>Årlig rabat: {{ tilvalgInformation.rabatKontant | dkCurrency }}</span>
                  }
                  @if (tilvalgInformation.rabatProcent) {
                    <span>Rabat: {{ tilvalgInformation.rabatProcent }} %</span>
                  }
                  @if (tilvalgInformation.isEngangsRabat) {
                    <span class="separator">⋅</span>
                    <span>Engangsrabat</span>
                  }
                </div>
              }
              @for (tilvalgnr of tilvalgInformation.tilvalg; track tilvalgnr; let i = $index) {
                @if (tilvalgnr) {
                  <span>{{ getTilvalgSummary(i, tilvalgnr) }}</span>
                  @if (i < tilvalgInformation.tilvalg.length - 1) {
                    <span class="separator">⋅</span>
                  }
                }
              }
            </div>
          }
        </ng-template>
        <app-tilvalg-form [form]="tilvalgForm" [tilvalgGroups]="tilvalgGroups" [kunde]="kunde" [partner]="selectedPartner"></app-tilvalg-form>
        <div class="form-btns">
          <button mat-raised-button matStepperPrevious>Tilbage</button>
          <button mat-raised-button matStepperNext color="primary" [disabled]="$safeNavigationMigration(tilvalgForm?.invalid)">Videre</button>
        </div>
      </mat-step>
    }
    <mat-step [stepControl]="sendLetterForm" #sendLetter>
      <ng-template matStepLabel>
        <div>Velkomstbrev</div>
      </ng-template>
      <div>Skal der sendes et velkomstbrev til kunden?</div>
      <app-send-letter [form]="sendLetterForm" [email]="$safeNavigationMigration(kunde?.anlaegsadresse?.email)" (reload)="reloadKundeinformation()"></app-send-letter>
      <div class="form-btns">
        <button mat-raised-button matStepperPrevious>Tilbage</button>
        <button
          appPreventDoubleClick
          (throttledClick)="onCreate()"
          [throttleTime]="1000"
          mat-raised-button
          color="primary"
          [disabled]="!sendLetterForm.valid || isLoading"
          >
          Opret
        </button>
      </div>
    </mat-step>
  </mat-vertical-stepper>
</div>
<div class="price-footer" [class.price-footer--has-message]>
  @if (priceComponents && canSeePriceInfo) {
    <button
      class="btn-icon fixedprice-active"
      matTooltip="Vis detaljer for pris"
      (click)="priceInfo()"
      >
      <mat-icon svgIcon="obs-solid" class="blue"></mat-icon>
    </button>
  }

  @if (!pricesWithoutMoms) {
    <div class="price-footer__item orange cursor-help" [matTooltip]="'moms: ' + ($safeNavigationMigration(totalPrice?.moms) | dkCurrency)">
      <div class="price-footer__row price-footer__row--first">
        Totalpris
        <small>
          &nbsp;·&nbsp; årlig
          @if (tilvalgInformation?.fastPrisEnabled) {
            , fastpris
          }
          @if (tilvalgInformation?.rabatEnabled) {
            , m. rabat
          }
        </small>
      </div>
      <div class="price-footer__row price-footer__row--last">
        @if (totalPrice) {
          <span>{{ totalPrice.withMoms | dkCurrency }}</span>
        }
        @if (!totalPrice) {
          <span>---</span>
        }
        @if (totalPrice) {
          <small class="price-moms">
            inkl.
            <br />
            moms
          </small>
        }
      </div>
    </div>
    @if (tilvalgInformation?.rabatEnabled || tilvalgInformation?.fastPrisEnabled) {
      <div
        class="price-footer__item cursor-help"
        [matTooltip]="'moms: ' + ($safeNavigationMigration(listPrice?.moms) | dkCurrency)"
        >
        <div class="price-footer__row price-footer__row--first">
          Listepris
          <small>&nbsp;·&nbsp; årlig</small>
        </div>
        <div class="price-footer__row price-footer__row--last">
          @if (listPrice) {
            <span>{{ listPrice.withMoms | dkCurrency }}</span>
          }
          @if (!listPrice) {
            <span>---</span>
          }
          @if (listPrice) {
            <small class="price-moms">
              inkl.
              <br />
              moms
            </small>
          }
        </div>
      </div>
    }
    <div class="price-footer__item cursor-help" [matTooltip]="'moms: ' + ($safeNavigationMigration(basePrice?.moms) | dkCurrency)">
      <div class="price-footer__row price-footer__row--first">
        Basispris
        <small>&nbsp;·&nbsp; årlig</small>
      </div>
      <div class="price-footer__row price-footer__row--last">
        @if (basePrice) {
          <span>{{ basePrice.withMoms | dkCurrency }}</span>
        }
        @if (!basePrice) {
          <span>---</span>
        }
        @if (basePrice) {
          <small class="price-moms">
            inkl.
            <br />
            moms
          </small>
        }
      </div>
    </div>
  }
  @if (pricesWithoutMoms) {
    <div class="price-footer__item orange cursor-help" [matTooltip]="'moms: ' + ($safeNavigationMigration(totalPrice?.moms) | dkCurrency)">
      @if (totalPrice) {
        <mat-icon svgIcon="obs-solid" class="blue"></mat-icon>
      }
      <div>
        <div class="price-footer__row price-footer__row--first">
          Totalpris
          <small>
            &nbsp;·&nbsp; årlig
            @if (tilvalgInformation?.fastPrisEnabled) {
              , fastpris
            }
            @if (tilvalgInformation?.rabatEnabled) {
              , m. rabat
            }
          </small>
        </div>
        <div class="price-footer__row price-footer__row--last">
          @if (totalPrice) {
            <span>{{ totalPrice.withoutMoms | dkCurrency }}</span>
          }
          @if (!totalPrice) {
            <span>---</span>
          }
          @if (totalPrice) {
            <small class="price-moms">
              ekskl.
              <br />
              moms
            </small>
          }
        </div>
      </div>
    </div>
    @if (tilvalgInformation?.rabatEnabled || tilvalgInformation?.fastPrisEnabled) {
      <div
        class="price-footer__item cursor-help"
        [matTooltip]="'moms: ' + ($safeNavigationMigration(listPrice?.moms) | dkCurrency)"
        >
        @if (listPrice) {
          <mat-icon svgIcon="obs-solid" class="blue"></mat-icon>
        }
        <div>
          <div class="price-footer__row price-footer__row--first">
            Listepris
            <small>&nbsp;·&nbsp; årlig</small>
          </div>
          <div class="price-footer__row price-footer__row--last">
            @if (listPrice) {
              <span>{{ listPrice.withoutMoms | dkCurrency }}</span>
            }
            @if (!listPrice) {
              <span>---</span>
            }
            @if (listPrice) {
              <small class="price-moms">
                ekskl.
                <br />
                moms
              </small>
            }
          </div>
        </div>
      </div>
    }
    <div class="price-footer__item cursor-help" [matTooltip]="'moms: ' + ($safeNavigationMigration(basePrice?.moms) | dkCurrency)">
      @if (basePrice && basePrice.withoutMoms > 0) {
        <mat-icon svgIcon="obs-solid" class="blue"></mat-icon>
      }
      <div>
        <div class="price-footer__row price-footer__row--first">
          Basispris
          <small>&nbsp;·&nbsp; årlig</small>
        </div>
        <div class="price-footer__row price-footer__row--last">
          @if (basePrice && basePrice.withoutMoms > 0) {
            <span>
              {{ basePrice.withoutMoms | dkCurrency }}
            </span>
          }
          @if (!basePrice) {
            <span>---</span>
          }
          @if (basePrice) {
            <small class="price-moms">
              ekskl.
              <br />
              moms
            </small>
          }
        </div>
      </div>
    </div>
    @if (g4Error) {
      <div class="price-footer__item price-footer__item--bold">
        <mat-icon svgIcon="alert-solid"></mat-icon>
        Kunne ikke hente priser i G4.
      </div>
    }
  }
</div>
